export const getGoogleMapApiKey = async (): Promise<string> => {
    const response = await fetch('/api/google-map-api-key');
    if (!response.ok) {
      throw new Error('Failed to fetch Google Map API key');
    }
    const data = await response.json();
    return data.apiKey;
  };